import { IonIcon } from '@ionic/react';
import { football } from 'ionicons/icons';

export const OwnGoalIcon: React.FC = () => (
  <IonIcon icon={football} style={{ color: 'red' }} />
);
